/* global axios */

import ApiClient from 'dashboard/api/ApiClient';

class WhatsappCampaignsAPI extends ApiClient {
  constructor() {
    super('custom/whatsapp_campaigns', { accountScoped: true });
  }

  preview(payload) {
    return axios.post(`${this.url}/preview`, payload);
  }

  confirm(payload) {
    return axios.post(`${this.url}/confirm`, payload);
  }

  status(campaignId, { page, status } = {}) {
    return axios.get(`${this.url}/${campaignId}/status`, {
      params: { page, status },
    });
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }
}

export default new WhatsappCampaignsAPI();
